export function doRangesIntersect(start1: number, len1: number, start2: number, len2: number): boolean {
  const end1 = start1 + len1;
  const end2 = start2 + len2;

  // If one range starts after the other one ends, they do not intersect
  // Otherwise, the ranges must intersect
  return !(start1 >= end2 || start2 >= end1);
}

export function isNullOrEmpty(str: string | null | undefined): boolean {
  return !str || str.trim().length === 0;
}

export function recalcImageRatioFromTwips(imageSizeInTwips: number, inches: number) {
  return Math.round(100 * ((inches * 1440) / imageSizeInTwips));
}
